import apiClient from "../../utils/api.client";
import { getOrganizationId } from "../../utils/session.utils";

/**
 * Obtiene la lista de juegos y sorteos activos
 * @param {number} organizationId - ID de la organización
 * @returns {Promise} Lista de juegos con sus sorteos
 */
export const getActiveGamesRaffles = async (
  organizationId = getOrganizationId(),
) => {
  try {
    const response = await apiClient.get(
      `/delivery-service/api/agency-orders/active-games-raffles?organizationId=${organizationId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error at getActiveGamesRaffles EP: ", error);
    throw error;
  }
};

/**
 * Crea un nuevo pedido desde una agencia
 * @param {number} agencyId - ID de la agencia
 * @param {Object} payload - Datos del pedido
 * @returns {Promise} Pedido creado
 */
export const createAgencyOrder = async (agencyId, payload) => {
  try {
    const response = await apiClient.post(
      `/delivery-service/api/agency-orders/agencies/${agencyId}/orders`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error at createAgencyOrder EP: ", error);
    throw error;
  }
};

/**
 * Obtiene la lista paginada de pedidos de una agencia
 * @param {number} agencyId - ID de la agencia
 * @param {Object} params - Parámetros de búsqueda (status, page, size)
 * @returns {Promise} Lista paginada de pedidos
 */
export const getAgencyOrders = async (agencyId, params = {}) => {
  try {
    const { status, page = 0, size = 20 } = params;
    let url = `/delivery-service/api/agency-orders/agencies/${agencyId}/orders?page=${page}&size=${size}`;
    if (status) {
      url += `&status=${status}`;
    }
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error at getAgencyOrders EP: ", error);
    throw error;
  }
};

/**
 * Obtiene el detalle completo de un pedido
 * @param {number} orderId - ID del pedido
 * @returns {Promise} Detalle del pedido
 */
export const getOrderDetail = async (orderId) => {
  try {
    const response = await apiClient.get(`/delivery-service/api/agency-orders/${orderId}`);
    return response.data;
  } catch (error) {
    console.error("Error at getOrderDetail EP: ", error);
    throw error;
  }
};

